//import "@fortawesome/fontawesome-pro/css/all.css";
import 'lightgallery/src/sass/lightgallery.scss';

import 'bootstrap';
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay, EffectFade } from 'swiper';
Swiper.use([Navigation, Pagination, Scrollbar, Autoplay, EffectFade]);

import basicNavigation from './header/header';
import inlineSVG from './utilities/convert-svg-to-html';
import {sliderLinks} from "./blocks/links-slider";
import {gallerySlider} from "./blocks/gallery";
import {testimonialsSlider} from "./blocks/testimonials";

import AOS from 'aos';
import {cluthaLocations} from "./blocks/clutha-locations";
import sidebarNav from "./header/sidebar";

$(function () {

    basicNavigation();
    sidebarNav();
    sliderLinks();
    gallerySlider();
    testimonialsSlider();
    cluthaLocations();

    inlineSVG('.navbar-logo, .footer-logo, .admin-logo');

    AOS.init({
        once: true,
        disable: function() {
            var maxWidth = 768;
            return window.innerWidth < maxWidth;
        }
    });


    var homeswiper = new Swiper(".home-carousel", {
        loop: true,
        effect: 'fade',
        speed: 500,
        slidesPerView: 1,
        allowTouchMove: false,
        autoplay: {
            delay: 3000,
        },
    });

    var headerswiper = new Swiper(".swiper-header", {
        loop: true,
        effect: 'fade',
        speed: 500,
        slidesPerView: 1,
        allowTouchMove: false,
        autoplay: {
            delay: 3000,
        },
    });

    $(".explore").click(function() {
        $('html,body').animate({
                scrollTop: $("#exploremore").offset().top},
            'slow');
    });

    //Menu
    $(".mega-menu").on('click', function (e) {
        e.stopPropagation();
    });

    $('.nav-item').on('click', function(){
        $(this).find('.parent-menu-inner:first-child .dropdown-parent-item').addClass('active');
        $(this).find('.sub-menu:first-child').removeClass('d-none');
    });

    $('.dropdown-parent-item').on('click', function(){
        $('.dropdown-parent-item').removeClass('active')
        $(this).addClass('active');
        let menuItem = $(this).attr('data-menu');
        $('.sub-menu').addClass('d-none');
        $('.sub-menu[data-menu='+ menuItem +']').removeClass('d-none');
    });

    $('.parent-no-children').on('click', function(){
        $('body').css('overflow', 'unset');
        ResetMenu();
        $('.dropdown-menu').removeClass('show');
    });

    $(document).on('click', function(){
       if($('.dropdown-menu').hasClass('show')) {
           $('body').css('overflow', 'hidden');
       } else {
           $('body').css('overflow', 'unset');
           ResetMenu();
       }
    });

    function ResetMenu() {
        $('.sub-menu').addClass('d-none');
        $('.dropdown-parent-item').removeClass('active');
    }
    //End Menu

    //team read more
    $('.team-modal-item').on('click', function(){
        var teamtitle = $(this).attr('data-attr-title');
        var teamposition = $(this).attr('data-attr-position');
        var teamcontent = $(this).attr('data-attr-content');

        $('.team-modal .team-title').html(teamtitle);
        $('.team-modal .team-position').html(teamposition);
        $('.team-modal .team-content').html(teamcontent);
    });


});

